@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.header {
  background-color: map.get(core.$colors, white);
  border-bottom: 1px solid map.get(core.$colors, iconHover);
  max-height: 68px;
  padding: 14px core.$layout-padding;

  @media screen and (max-width: core.$fullHD) and (min-width: core.$laptopL) {
    padding: 14px core.$layout-padding;
  }

  &Collapsed {
    padding: 14px core.$layout-padding;

    @media screen and (max-width: core.$fullHD) and (min-width: core.$laptopL) {
      padding: 14px core.$layout-padding;
    }
  }
}
